import globals from "@lvt/globals";
import { createAsyncThunk, SerializedError } from "@reduxjs/toolkit";
import Ajv from "ajv";
import axios from "axios";
import applyCaseMiddleware from "axios-case-converter";

import { addAlert, Severity } from "@/store/alerts/slice";


export interface Client {
    id: number;
    name: string;
}

const fetchClientsSchema = {
    type: "object",
    required: ["status", "statusMessage", "data"],
    additionalProperties: false,
    properties: {
        status: { const: 200 },
        statusMessage: { type: "string" },
        data: {
            type: "array",
            items: {
                type: "object",
                required: ["id", "name"],
                additionalProperties: true,
                properties: {
                    id: { type: "integer" },
                    name: { type: "string" },
                },
            },
        },
    },
};

const fetchClientsValidator = new Ajv().compile(fetchClientsSchema);

export const fetchClients = createAsyncThunk("fetchClients", async (_, { dispatch }) => {
    try {
        const client = applyCaseMiddleware(
            axios.create({
                baseURL: globals.userdashboard.proxyUrl,
            }),
        );

        const response = await client.get("/api/clients?page_type=streaming", {
            withCredentials: true,
        });

        if (fetchClientsValidator(response.data)) {
            return response.data.data as Array<Client>;
        } else {
            const error: SerializedError = {
                name: "validation",
                message: JSON.stringify(fetchClientsValidator.errors),
            };

            throw error;
        }
    } catch (e) {
        dispatch(
            addAlert({
                severity: Severity.Error,
                message: "Failed to retrieve clients",
            }),
        );

        throw e;
    }
});
